import { DurationFormat } from "@formatjs/intl-durationformat";
import type { Duration, Period } from "@js-joda/core";

export function formatDuration(d: Duration): string {
  const days = d.toDays();
  const hours = d.minusDays(days).toHours();
  const minutes = d.minusHours(d.toHours()).toMinutes();
  const seconds = d.minusMinutes(d.toMinutes()).seconds();

  const fmt = new DurationFormat(navigator.language, {
    secondsDisplay: d.isZero() ? "always" : "auto",
  });

  return fmt.format({ days, hours, minutes, seconds });
}

export function formatPeriod(p: Period): string {
  const years = p.years();
  const months = p.months();
  const days = p.days();

  const fmt = new DurationFormat(navigator.language, {
    daysDisplay: p.isZero() ? "always" : "auto",
  });

  return fmt.format({ years, months, days });
}
